import React from 'react';

const InternalServer = (props) => {
    return (
        <h1>500 SERVER ERROR, CONTACT ADMINISTRATOR!!!!</h1>
    )
}

export default InternalServer;